import { render, staticRenderFns } from "./ModalEditarDiaCobranca.vue?vue&type=template&id=b7853292&"
import script from "./ModalEditarDiaCobranca.vue?vue&type=script&lang=js&"
export * from "./ModalEditarDiaCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports